import { useRouter } from 'next/router';
import Icon from '@components/common/assets';
import Text from '@components/position/jd/apply/modals/previewProfileModal/additionInfo/Text';
import SingleChoice from '@components/position/jd/apply/modals/previewProfileModal/additionInfo/SingleChoice';
import MultiChoice from '@components/position/jd/apply/modals/previewProfileModal/additionInfo/MultiChoice';
import Dropdown from '@components/position/jd/apply/modals/previewProfileModal/additionInfo/Dropdown';
import File from '@components/position/jd/apply/modals/previewProfileModal/additionInfo/File';

import { useAdditionalItems } from '@repository/match';
import { AnswerVO } from '@domain/vo/match/ResumeAdditionInfoVO';
import classnames from 'classnames/bind';
import styles from './addtionInfo.module.scss';
const cx = classnames.bind(styles);

const AdditionInfo = () => {
  const { query } = useRouter();
  const positionSn = Number(query.sn);
  const { data: additionalItem } = useAdditionalItems(positionSn);
  const saveAnswers = additionalItem?.additionInfo.map((item) => item.answer);
  const validSaveAnswers = saveAnswers?.filter((item): item is AnswerVO => item !== null);

  if (!validSaveAnswers || validSaveAnswers.length === 0) return null;
  const formElements = validSaveAnswers?.map((form) => {
    switch (form.type) {
      case 'TEXT':
        return <Text key={form.question} {...form} />;
      case 'SINGLE_CHOICE':
        return <SingleChoice key={form.question} {...form} />;
      case 'MULTI_CHOICE':
        return <MultiChoice key={form.question} {...form} />;
      case 'DROPDOWN':
        return <Dropdown key={form.question} {...form} />;
      case 'ADDITION_ATTACH_FILE':
        return <File key={form.question} {...form} />;
      default:
        return null;
    }
  });

  return (
    <section className={cx('addtionInfoWrapper')}>
      <h2 className={cx('title')}>
        <Icon name="fileAddLight" width={40} height={40} />
        추가 정보
      </h2>

      <div className={cx('formArea')}>{formElements}</div>
    </section>
  );
};

export default AdditionInfo;
